const lv = {
  brand: "E2 Care",
  tagline: "Mierīga, savienota aprūpe.",
  nav_dashboard: "Pārskats",
  nav_residents: "Pacienti",
  nav_patients: "Pacienti",
  nav_rooms: "Telpas",
  nav_devices: "Ierīces",
  nav_events: "Notikumi",
  nav_alerts: "Brīdinājumi",
  nav_users: "Komanda",
  nav_settings: "Iestatījumi",
  nav_admin: "Administrēšana",
  nav_signout: "Iziet",
  topbar_search_placeholder: "Meklēt pacientus, telpas, ierīces…",
  admin_super_only: "Tikai super-administratori var pārvaldīt organizācijas.",
  admin_admin_only: "Tikai administratori var piekļūt šai lapai.",
  admin_tab_orgs: "Organizācijas",
  admin_tab_users: "Lietotāji",
  admin_tab_patients: "Pacienti",
  admin_tab_rooms: "Telpas",
  admin_tab_buildings: "Ēkas",
  admin_tab_devices: "Ierīces",
  admin_tab_alerts: "Brīdinājumi",
  admin_tab_qa: "Testa rīki",
  admin_delete: "Dzēst",
  admin_no_orgs_yet: "Vēl nav organizāciju.",
  admin_field_name: "Nosaukums",
  admin_field_email: "E-pasts",
  admin_field_phone: "Tālrunis",
  admin_field_password: "Parole",
  admin_field_role: "Loma",
  admin_field_type: "Tips",
  admin_field_timezone: "Laika josla",
  admin_field_address: "Adrese",
  admin_field_status: "Statuss",
  admin_field_organization: "Organizācija",
  admin_password_keep: "Atstājiet tukšu, lai saglabātu",
  admin_field_birth_date: "Dzimšanas datums",
  admin_field_room: "Telpa",
  admin_field_room_none: "Nepiešķirts",
  admin_field_photo: "Foto URL",
  admin_field_photo_hint: "Ielīmējiet publisku URL — augšupielāde v2.",
  admin_field_notes: "Aprūpētāja piezīmes",
  admin_field_emergency_contact: "Galvenais ārkārtas kontakts",
  admin_field_ec_name: "Vārds",
  admin_field_ec_phone: "Tālrunis",
  admin_field_ec_relationship: "Attiecības",
  admin_field_mac: "MAC adrese",
  admin_field_firmware: "Programmaparatūra",
  admin_field_assignment: "Piesaistīts",
  admin_field_assigned_room: "Piesaistītā telpa",
  admin_field_assigned_patient: "Piesaistītais pacients",
  admin_field_assigned_hint: "Pēc izvēles. Sensori — telpai; aproces — pacientam.",
  admin_field_sensor_target: "Piestiprināts pie",
  admin_field_sensor_target_hint: "Norāda sistēmai, vai šis sensors uzrauga durvis vai logu.",
  sensor_target_door: "Durvis",
  sensor_target_window: "Logs",
  sensor_target_unset: "Nav konfigurēts",
  admin_field_sensor_label: "Sensora etiķete",
  admin_field_sensor_label_hint: "Draudzīgs nosaukums, kas redzams brīdinājumos un notikumos — piem., „Priekšējās durvis“, „Vannas istabas logs“.",
  admin_field_building: "Ēka",
  admin_field_building_required: "Istabai jāpieder ēkai.",
  room_openings: "Ailas",
  room_no_openings: "Šajā istabā vēl nav uzstādīti durvju vai logu sensori.",
  room_openings_summary: "{doors} {doorsLabel} · {windows} {windowsLabel}",
  opening_last_event: "Pēdējās izmaiņas",
  admin_field_description: "Apraksts",
  admin_field_severity: "Smagums",
  admin_field_patient: "Pacients",
  admin_field_device: "Ierīce",
  admin_field_message: "Ziņojums",
  admin_orgs_title: "Organizācijas",
  admin_orgs_sub: "Izveidojiet, rediģējiet un arhivējiet E2 Care nomniekus.",
  admin_orgs_count: "organizācijas",
  admin_org_new: "Jauna organizācija",
  admin_org_new_title: "Jauna organizācija",
  admin_org_edit_title: "Rediģēt organizāciju",
  admin_org_created: "Organizācija izveidota.",
  admin_org_updated: "Organizācija atjaunināta.",
  admin_org_deleted: "Organizācija arhivēta.",
  admin_org_delete_title: "Arhivēt organizāciju?",
  admin_org_delete_confirm: "\"{name}\" tiks paslēpta no sarakstiem.",
  admin_users_title: "Lietotāji",
  admin_users_sub_super: "Pārvaldiet visus lietotāju kontus.",
  admin_users_sub_org: "Pārvaldiet lietotāju kontus {org}.",
  admin_user_new: "Jauns lietotājs",
  admin_user_new_title: "Jauns lietotājs",
  admin_user_edit_title: "Rediģēt lietotāju",
  admin_user_created: "Lietotājs izveidots.",
  admin_user_updated: "Lietotājs atjaunināts.",
  admin_user_deleted: "Lietotājs arhivēts.",
  admin_user_delete_title: "Arhivēt lietotāju?",
  admin_user_delete_confirm: "\"{name}\" zaudēs piekļuvi.",
  admin_user_memberships: "Organizāciju dalība",
  admin_patients_title: "Pacienti",
  admin_patients_sub_super: "Pārvaldiet visus pacientu ierakstus.",
  admin_patients_sub_org: "Pārvaldiet pacientus {org}.",
  admin_patient_new: "Jauns pacients",
  admin_patient_new_title: "Jauns pacients",
  admin_patient_edit_title: "Rediģēt pacientu",
  admin_patient_created: "Pacients izveidots.",
  admin_patient_updated: "Pacients atjaunināts.",
  admin_patient_deleted: "Pacients arhivēts.",
  admin_patient_delete_title: "Arhivēt pacientu?",
  admin_patient_delete_confirm: "\"{name}\" tiks paslēpts no sarakstiem.",
  admin_rooms_title: "Telpas",
  admin_rooms_sub_super: "Konfigurējiet telpas.",
  admin_rooms_sub_org: "Konfigurējiet telpas {org}.",
  admin_room_new: "Jauna telpa",
  admin_room_new_title: "Jauna telpa",
  admin_room_edit_title: "Rediģēt telpu",
  admin_room_created: "Telpa izveidota.",
  admin_room_updated: "Telpa atjaunināta.",
  admin_room_deleted: "Telpa arhivēta.",
  admin_room_delete_title: "Arhivēt telpu?",
  admin_room_delete_confirm: "\"{name}\" tiks paslēpta.",
  admin_devices_title: "Ierīces",
  admin_devices_sub_super: "Pievienojiet Moko ierīces.",
  admin_devices_sub_org: "Pievienojiet Moko ierīces {org}.",
  admin_device_new: "Jauna ierīce",
  admin_device_new_title: "Jauna ierīce",
  admin_device_edit_title: "Rediģēt ierīci",
  admin_device_created: "Ierīce izveidota.",
  admin_device_updated: "Ierīce atjaunināta.",
  admin_device_deleted: "Ierīce arhivēta.",
  admin_device_delete_title: "Arhivēt ierīci?",
  admin_device_delete_confirm: "Ierīce {mac} tiks paslēpta.",
  admin_buildings_title: "Ēkas",
  admin_buildings_sub_super: "Grupējiet telpas pa ēkām.",
  admin_buildings_sub_org: "Grupējiet telpas pa ēkām {org}.",
  admin_building_new: "Jauna ēka",
  admin_building_new_title: "Jauna ēka",
  admin_building_edit_title: "Rediģēt ēku",
  admin_building_created: "Ēka izveidota.",
  admin_building_updated: "Ēka atjaunināta.",
  admin_building_deleted: "Ēka arhivēta.",
  admin_building_delete_title: "Arhivēt ēku?",
  admin_building_delete_confirm: "\"{name}\" tiks paslēpta.",
  admin_qa_title: "Testa rīki",
  admin_qa_sub: "Ievadiet notikumus, lai pārbaudītu plūsmu.",
  admin_qa_event_title: "Ievadīt testa notikumu",
  admin_qa_event_sub: "Simulē Moko webhook.",
  admin_qa_alert_title: "Ievadīt testa brīdinājumu",
  admin_qa_alert_sub: "Apej notikumu līmeni.",
  admin_qa_inject_event: "Ievadīt notikumu",
  admin_qa_inject_alert: "Ievadīt brīdinājumu",
  admin_qa_event_done: "Notikums ievadīts.",
  admin_qa_alert_done: "Brīdinājums ievadīts.",
  admin_qa_disclaimer: "Šiem galapunktiem ražošanā jābūt deaktivizētiem.",
  admin_alerts_title: "Brīdinājumu politika",
  admin_alerts_sub: "Organizācijas mēroga brīdinājumu noteikumi: {org}.",
  admin_alerts_quiet_title: "Klusās stundas",
  admin_alerts_quiet_desc: "Norādiet, kad šī organizācija ir nakts režīmā.",
  admin_alerts_quiet_hint: "Laiks tiek interpretēts organizācijas vietējā laika joslā. Intervāls drīkst pāriet pāri pusnaktij (piem. 22:00 → 06:00).",
  admin_alerts_night_start: "Nakts sākas",
  admin_alerts_night_end: "Nakts beidzas",
  admin_alerts_load_failed: "Ielādēt brīdinājumu politiku",
  admin_alerts_save_failed: "Saglabāt brīdinājumu politiku",
  admin_alerts_saved: "Brīdinājumu politika saglabāta.",
  admin_alerts_clear_title: "Notīrīt aktīvos brīdinājumus",
  admin_alerts_clear_desc: "Vienā klikšķī apstipriniet visus atvērtos brīdinājumus šajā organizācijā.",
  admin_alerts_clear_hint: "Apstiprinātie brīdinājumi paliek vēsturē.",
  admin_alerts_ack_all_button: "Apstiprināt visus",
  admin_alerts_ack_all_title: "Apstiprināt visus aktīvos brīdinājumus?",
  admin_alerts_ack_all_confirm: "Tas apstiprinās katru atvērto brīdinājumu šeit: {org}. Šo darbību nevar atsaukt.",
  admin_alerts_ack_all_done: "Apstiprināti {count} brīdinājumi.",
  admin_alerts_ack_all_done_generic: "Visi aktīvie brīdinājumi apstiprināti.",
  admin_alerts_ack_all_failed: "Apstiprināt visus brīdinājumus",
  org_type_nursing_home: "Pansionāts",
  org_type_assisted_living: "Aprūpes māja",
  org_type_hospital: "Slimnīca",
  org_type_home_care: "Mājas aprūpe",
  role_admin: "Administrators",
  role_caregiver: "Aprūpētājs",
  role_family: "Ģimene",
  status_active: "aktīvs",
  status_inactive: "neaktīvs",
  confirm: "Apstiprināt",
  sign_in: "Ieiet",
  sign_up: "Reģistrēties",
  email: "E-pasts",
  password: "Parole",
  full_name: "Pilns vārds",
  create_account: "Izveidot kontu",
  no_account: "Vēl nav konta?",
  have_account: "Jau ir konts?",
  login_welcome: "Laipni lūdzam atpakaļ",
  login_sub: "Ieiet, lai turpinātu uzraudzīt iedzīvotājus.",
  register_welcome: "Pievienojies E2 Care",
  register_sub: "Izveido darba vietu minūtē.",
  total_residents: "Pacienti",
  active_devices: "Aktīvas ierīces",
  open_alerts: "Atvērti brīdinājumi",
  offline_gateways: "Bezsaistes ierīces",
  falls_7d: "Kritieni (7d)",
  sos_7d: "SOS (7d)",
  low_battery: "Zems akumulators",
  critical_residents: "Kritiski",
  status_ok: "Viss kārtībā",
  status_warning: "Uzmanību",
  status_critical: "Kritiski",
  status_online: "Tiešsaistē",
  status_offline: "Bezsaistē",
  search: "Meklēt",
  filter: "Filtrs",
  all: "Visi",
  refresh: "Atjaunot",
  loading: "Ielādē…",
  no_results: "Šeit pagaidām nekā nav.",
  view_profile: "Skatīt profilu",
  showing_n_of_m: "Rāda {n} no {m}",
  load_more: "Ielādēt vairāk",
  auto_refresh: "Tiešsaistē · auto atjauno",
  auto_refresh_paused: "Apturēts",
  updated_just_now: "Atjaunots tikko",
  updated_n_sec_ago: "Atjaunots pirms {n}s",
  updated_n_min_ago: "Atjaunots pirms {n}m",
  acknowledge: "Apstiprināt",
  acknowledged: "Apstiprināts",
  ack_all: "Apstiprināt visus",
  ack_all_confirm: "Apstiprināt visus {count} aktīvos brīdinājumus?",
  ack_all_running: "Apstiprina…",
  ack_all_done: "{count} brīdinājums(-i) apstiprināts.",
  ack_all_partial: "{ok} apstiprināts · {fail} neizdevās.",
  last_seen: "Pēdējo reizi",
  battery: "Akumulators",
  signal: "Signāls",
  firmware: "Programmatūra",
  room: "Telpa",
  age: "Vecums",
  emergency_contact: "Ārkārtas kontakts",
  notes: "Piezīmes",
  assigned_devices: "Piešķirtas ierīces",
  recent_events: "Jaunākie notikumi",
  timeline_24h: "Pēdējās 24 stundas",
  delivery_status: "Piegādes statuss",
  acknowledged_by: "Apstiprināja",
  dashboard_title: "Māju pārskats",
  dashboard_sub: "Ātrs pārskats par aprūpējamām mājām.",
  residents_title: "Pacienti",
  residents_sub: "Cilvēki, kurus šobrīd uzraugāt.",
  devices_title: "Ierīces",
  devices_sub: "Sensori un aproces.",
  devices_sub_admin: "Vārtejas, sensori un aproces.",
  events_title: "Tiešie notikumi",
  events_sub: "Hronoloģiska plūsma.",
  alerts_title: "Brīdinājumi",
  alerts_sub: "Paziņojumi ģimenei un aprūpētājiem.",
  settings_title: "Iestatījumi",
  settings_sub: "Jūsu izvēles.",
  users_title: "Komanda",
  users_sub: "Aprūpētāji, ģimene un administratori.",
  falls_chart_title: "Kritieni un SOS — pēdējās 7 dienās",
  recent_alerts_title: "Jaunākie kritiskie brīdinājumi",
  no_alerts: "Nav atvērtu brīdinājumu. Visi ir drošībā.",
  event_fall: "Atklāts kritiens",
  event_sos: "Nospiesta SOS poga",
  event_door_open: "Atvērtas durvis",
  event_door_close: "Aizvērtas durvis",
  event_inactivity: "Ilgstoša neaktivitāte",
  event_low_battery: "Zems akumulators",
  event_offline: "Ierīce bezsaistē",
  event_online: "Ierīce atkal tiešsaistē",
  event_heartbeat: "Sirdsdarbība",
  event_button_press: "Nospiesta poga",
  device_gateway: "Bluetooth vārteja",
  device_door_sensor: "Durvju sensors",
  device_bracelet: "Aproce",
  device_unknown: "Nezināma ierīce",
  language: "Valoda",
  notifications: "Paziņojumi",
  quiet_hours: "Klusā stunda",
  escalation: "Eskalācijas politika",
  just_now: "tikko",
  min_ago: "min atpakaļ",
  h_ago: "st atpakaļ",
  d_ago: "d atpakaļ",
  demo_hint: "Demo konts: admin@e2care.lv / Care2024!",
  open_menu: "Atvērt izvēlni",
  close_menu: "Aizvērt izvēlni",
  care_team: "Aprūpes komanda",
  family_members: "Ģimene",
  no_caregivers: "Vēl nav piešķirts neviens aprūpētājs.",
  no_family: "Vēl nav saistīts neviens ģimenes loceklis.",
  add_caregiver: "Pievienot aprūpētāju",
  add_family: "Pievienot ģimenes locekli",
  select_user: "Izvēlies lietotāju…",
  cancel: "Atcelt",
  add: "Pievienot",
  remove: "Noņemt",
  save: "Saglabāt",
  relationship: "Radniecība",
  relationship_son: "Dēls",
  relationship_daughter: "Meita",
  relationship_spouse: "Laulātais",
  relationship_other: "Cits",
  notify_via: "Paziņot caur",
  call_contact: "Zvanīt",
  view_resident: "Atvērt profilu",
  address: "Adrese",
  admin_only_section: "Administratora rīki",
  rooms_title: "Telpas",
  rooms_sub: "Visas uzraudzītās telpas.",
  room_name: "Telpa",
  room_type: "Tips",
  room_type_private_room: "Privāta telpa",
  room_type_shared_room: "Kopēja telpa",
  room_type_apartment: "Dzīvoklis",
  room_type_corridor: "Gaitenis",
  room_type_common_area: "Koplietošanas telpa",
  room_floor: "Stāvs",
  room_state: "Pašreizējais stāvoklis",
  door: "Durvis",
  window: "Logs",
  door_open_state: "Atvērts",
  door_closed_state: "Aizvērts",
  door_unknown_state: "Nezināms",
  room_no_devices: "Šajā telpā vēl nav ierīču.",
  room_no_patients: "Šajā telpā vēl nav pacientu.",
  room_patients: "Pacienti telpā",
  room_devices: "Ierīces telpā",
  room_activity: "Aktivitātes laika līnija",
  rooms_filter_all_types: "Visi veidi",
  widget_active_alerts: "Aktīvie brīdinājumi",
  widget_active_alerts_sub: "Kritiski, neatrisināti un apstiprināti",
  widget_patients_status: "Pacientu statuss",
  widget_devices_health: "Ierīču veselība",
  widget_room_activity: "Telpu aktivitāte",
  widget_recent_events: "Tiešraides notikumi",
  widget_connectivity: "Savienojamība",
  metric_critical: "Kritiski",
  metric_unresolved: "Neatrisināti",
  metric_acknowledged_count: "Apstiprināti",
  metric_total: "Kopā",
  metric_active: "Aktīvi",
  metric_online: "Tiešsaistē",
  metric_offline: "Bezsaistē",
  metric_ota_pending: "OTA gaida",
  metric_battery_warn: "Zems akumulators",
  metric_doors_open: "Atvērtas durvis",
  metric_windows_open: "Atvērti logi",
  metric_signal_avg: "Vidējais signāls",
  metric_last_comm: "Pēdējā komunikācija",
  metric_packets: "Paketes / h",
  view_all: "Skatīt visu",
  status_new: "Jauns",
  status_acknowledged: "Apstiprināts",
  status_resolved: "Atrisināts",
  status_resolved_local: "Atrisināts (lokāli)",
  resolve: "Atrisināt",
  add_note: "Pievienot piezīmi",
  save_note: "Saglabāt piezīmi",
  resolve_local_badge: "tikai šajā ierīcē",
  resolve_local_hint: "Atzīmē brīdinājumu kā atrisinātu tikai šajā pārlūkā. Komandai un serverim tas joprojām ir atvērts.",
  note_placeholder: "Pievieno kontekstu komandai…",
  notes_count: "{n} piezīme(s)",
  device_detail: "Ierīces dati",
  device_diagnostics: "Diagnostika",
  device_firmware_history: "Programmatūras vēsture",
  device_ota_config: "OTA konfigurācija",
  device_ota_status: "OTA statuss",
  device_signal: "Signāla kvalitāte",
  device_mac: "MAC adrese",
  device_serial: "Sērijas numurs",
  fall_sensitivity: "Kritiena jutība",
  transmission_interval: "Pārraides intervāls",
  low_battery_threshold: "Zema akumulatora slieksnis",
  ota_idle: "Dīkstāvē",
  ota_pending: "Gaida",
  ota_deploying: "Izvieto",
  ota_failed: "Neizdevās",
  events_filter_severity: "Smagums",
  events_filter_room: "Telpa",
  events_filter_patient: "Pacients",
  events_filter_device: "Ierīce",
  severity_info: "Info",
  severity_warning: "Brīdinājums",
  severity_critical: "Kritisks",
  telegram_title: "Telegram brīdinājumi",
  telegram_desc: "Saņemiet Telegram brīdinājumus par pacientiem, kas jums piešķirti.",
  telegram_connect: "Pieslēgt Telegram",
  telegram_connected: "Telegram pieslēgts",
  telegram_connected_as: "Pieslēgts Telegram kā {name}",
  telegram_connect_success: "Telegram veiksmīgi pieslēgts",
  telegram_connect_error: "Neizdevās pieslēgt Telegram. Lūdzu, mēģiniet vēlreiz.",
  telegram_missing_bot: "Telegram bots nav konfigurēts.",
  telegram_disconnect: "Atvienot",
  telegram_disconnect_success: "Telegram atvienots.",
  telegram_disconnect_error: "Neizdevās atvienot Telegram. Lūdzu, mēģiniet vēlreiz.",
  telegram_already_linked: "Šis Telegram konts jau ir saistīts ar citu e2-care lietotāju.",
  telegram_switch_q: "Izmantot citu Telegram kontu?",
  telegram_switch_intro: "Telegram atceras, kurš konts ir pieteicies visās vietnēs. Lai izmantotu citu:",
  telegram_switch_step1: "Atveriet Telegram Web un izrakstieties no pašreizējā konta.",
  telegram_switch_step2: "Atgriezieties šeit un pārlādējiet zemāk esošo pogu, pēc tam piesakieties ar otru kontu.",
  telegram_open_web: "Atvērt Telegram Web",
  telegram_reload_widget: "Es izrakstījos — pārlādēt pogu",
  lang_autodetected_toast: "Atklāta jūsu valoda: {language}. To var mainīt iestatījumos.",
  admin_view_active: "Aktīvi",
  admin_view_archived: "Arhivēti",
  admin_restore: "Atjaunot",
  admin_restored: "Atjaunots.",
  admin_hard_delete: "Dzēst neatgriezeniski",
  admin_hard_delete_title: "Dzēst neatgriezeniski?",
  admin_hard_delete_confirm: "«{name}» tiks neatgriezeniski izdzēsts no datu bāzes. Šo darbību nevar atsaukt.",
  admin_hard_deleted: "Neatgriezeniski izdzēsts.",
  admin_no_archived: "Nav arhivētu vienumu.",
  language_desc: "Tiek izmantota lietotnes saskarnei un jūsu Telegram + push paziņojumiem.",
  language_saved: "Valoda atjaunināta.",
  language_error: "Neizdevās atjaunināt valodu. Lūdzu, mēģiniet vēlreiz.",
  admin_field_language: "Valoda",
  edit: "Rediģēt",
  generic_error: "Kaut kas nogāja greizi. Lūdzu, mēģiniet vēlreiz.",
  caregiver_added: "Aprūpētājs pievienots.",
  caregiver_removed: "Aprūpētājs noņemts.",
  family_added: "Ģimenes loceklis pievienots.",
  family_removed: "Ģimenes loceklis noņemts.",
  menu: "Izvēlne",
  dl_companion_app: "Pavadošā lietotne",
  dl_hero_title: "E2 Care operētājsistēmai Android",
  dl_hero_sub: "Instalējiet pavadošo lietotni Moko aprīkotā tālrunī, lai pārsūtītu brīdinājumus, konfigurētu ierīces un uzturētu saikni ar savu aprūpes komandu — pat tad, kad informācijas panelis ir aizvērts.",
  dl_android_apk: "Android APK",
  dl_version_loading: "ielādē versiju…",
  dl_released: "Izlaists {date}",
  dl_download_apk: "Lejupielādēt APK",
  dl_unavailable: "Nav pieejams",
  dl_preparing: "Sagatavo…",
  dl_manifest_error: "Neizdevās ielādēt manifestu. Mēģiniet atsvaidzināt — ja problēma turpinās, būvēšanas serveris, iespējams, tiek atkārtoti izvietots.",
  dl_whats_new: "Kas jauns",
  dl_installing_title: "Instalēšana jūsu tālrunī",
  dl_step1: "Pieskarieties „Lejupielādēt APK“ augšā. Jūsu pārlūks var brīdināt, ka APK faili var kaitēt ierīcei — šis brīdinājums ir normāls jebkuram instalētājam, kas lejupielādēts ārpus Play Store.",
  dl_step2: "Atveriet lejupielādēto failu. Android pirmajā reizē lūgs atļaut instalēšanu no šī pārlūka — ieslēdziet atļauju un atgriezieties.",
  dl_step3: "Pieskarieties „Instalēt“, pēc tam „Atvērt“, kad tas ir pabeigts.",
  dl_step4: "Piesakieties ar saviem E2 Care akreditācijas datiem.",
  dl_iphone_note: "iPhone versija būs pieejama vēlāk. Pagaidām, lūdzu, izmantojiet tīmekļa informācijas paneli.",
  dl_back_to_dashboard: "Atpakaļ uz informācijas paneli",
  dl_android_min: "Android {version}+",
  admin_device_org_change_hint: "Mainot organizāciju, tiek notīrīts pašreizējais istabas un pacienta piešķīrums.",
  admin_view_full: "Pilns saraksts",
  device_filter_assignment: "Piešķīrums",
  device_filter_patient: "Piešķirts pacientam",
  device_filter_room: "Piešķirts istabai",
  device_filter_unassigned: "Nepiešķirts",
  admin_all_orgs: "Visas organizācijas",
  pagination_prev: "Iepriekšējā",
  pagination_next: "Nākamā",
  pagination_per_page: "Vienā lapā",
  pagination_page_of: "Lapa {page} no {pages}",
  pagination_total: "Kopā {total}",
};
export default lv;
